import { LazyLoader as bdtv_3037d81e3ec5 } from "@Bondit2Theme/mod-fipefi";

class bdtv_fc1fffba6106 extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  initData() {
    const bdtv_08a6ea57f48b = JSON.parse(
      localStorage.getItem("bdt-recente-visto-artigos")
    );
    this.getStoredProducts(bdtv_08a6ea57f48b);
  }
  getStoredProducts(bdtv_5cd6416528d9) {
    const bdtv_5f4d4055b977 = this.dataset?.bdtKala;
    if (bdtv_5f4d4055b977) {
      let bdtv_961d9722d084 = "";
      var bdtv_8de06ca4b9e9 = "";
      if (bdtv_5cd6416528d9 && bdtv_5cd6416528d9.length > 0) {
        const bdtv_c626a3bcc70b = bdtv_5cd6416528d9.slice();
        const bdtv_a67507a0b070 = bdtv_c626a3bcc70b.slice(0, bdtv_5f4d4055b977);
        bdtv_961d9722d084 = bdtv_a67507a0b070.join("%20OR%20id:");
        bdtv_8de06ca4b9e9 = `&q=id:${bdtv_961d9722d084}`;
      }
    }
    fetch(`${this.dataset.bdtMipo}${bdtv_8de06ca4b9e9}`)
      .then((bdtv_92e8f6673b54) => bdtv_92e8f6673b54.text())
      .then((bdtv_e787f0648fad) => {
        const bdtv_554913694d76 = document.createElement("div");
        bdtv_554913694d76.innerHTML = bdtv_e787f0648fad;
        const bdtv_12e059dae275 = bdtv_554913694d76.querySelector("bdt-recente-visto-artigos"
        );
        if (
          bdtv_12e059dae275 &&
          bdtv_12e059dae275.innerHTML.trim().length
        ) {
          this.innerHTML = bdtv_12e059dae275.innerHTML;
        }
        new bdtv_3037d81e3ec5(".bdt-figura-zora-no");
      })
      .finally(() => {})
      .catch((bdtv_f6107d17d0d4) => {
        console.error(bdtv_f6107d17d0d4);
      });
  }
  connectedCallback() {
    const bdtv_3336acd304c5 = this;
    const bdtv_90066c85ce42 = (bdtv_58035076fe21, bdtv_6c205a43ab8b) => {
      if (!bdtv_58035076fe21[0].isIntersecting) return;
      bdtv_6c205a43ab8b.unobserve(this);
      bdtv_3336acd304c5.initData();
    };

    new IntersectionObserver(bdtv_90066c85ce42.bind(this), {
      rootMargin: "0px 0px 100px 0px",
    }).observe(this);
  }
}
customElements.define("bdt-recente-visto-artigos", bdtv_fc1fffba6106);